import { ActionType } from "../actions/pos";

export const initialState = {

  list: [],             // TEMP: keep for old screens during migration
  
  categoriesList: [],       // POS categories
  expenseCategories: [], // expense categories
  inventoryList: [],        // POS Inventory grid
  productsList: [],    // POS product grid
  posItems: [], // products enabled for POS settings as its own data slice.
  searchResults: [],    // barcode/name search
  suppliersList: [], // supplier grid
  customersList: [], // customer grid 

  type: "",
  data: {},
  bool: false,

  authUser: {},
  stores: [],
  defStore: {},
};


export const pos = (state = initialState, action) => {
  console.log("ACTION:", action.type);
  switch (action.type) {
    case ActionType.List:
      return {
        ...state,
        list: [...action.payload.result],
        type: action.payload.type,
      };
    case ActionType.AddItem:
      return {
        ...state,
        list: [action.payload.result, ...state.list],
        type: action.payload.type,
      };
    case ActionType.UpdateItem:
      return {
        ...state,
        list: state.list.map((j) =>
          j.id === action.payload.result.id ? action.payload.result : j
        ),
      };
    case ActionType.Data:
      return {
        ...state,
        data: action.payload.result,
        type: action.payload.type,
      };
    case ActionType.RmvList:
      return {
        ...state,
        list: state.list.filter((j) => j.id !== action.payload.result.id),
      };
    case ActionType.Check:
      return {
        ...state,
        type: action.payload.type,
        bool: action.payload.result,
      };
    case ActionType.Auth:
      return {
        ...state,
        authUser: action.payload.result,
      };

    case ActionType.Store:
      return {
        ...state,
        stores: action.payload.result,
      };
    case ActionType.DefStore:
      return {
        ...state,
        defStore: action.payload.result,
      };
    case ActionType.RmvStore:
      return {
        ...state,
        stores: state.stores.filter((j) => j.id !== action.payload.result.id),
      };
      
    case ActionType.ClearLi:
      return {
        ...state,
        list: [],
        type: "",
      };
    case ActionType.ClearData:
      return {
        ...state,
        data: {},
        type: "",
      };

      //add new actions for POS inventory, categories, and search results

      case ActionType.SetSuppliers:
          console.log(
              "SET_SUPPLIERS payload:",
              action.payload
            );
        return {
          ...state,
          suppliersList: action.payload.result,
        };

        case ActionType.RmvSupplier:
          return {
            ...state,
            suppliersList: state.suppliersList.filter(
              (j) => j.id !== action.id
            ),
          };

      case ActionType.SetCustomers:
        console.log(
          "SET_CUSTOMERS payload:",
          action.payload
        );

        return {
          ...state,
          customersList: action.payload.result || [],
        };
      
      case ActionType.RmvCustomer:
        return {
          ...state,
          customersList: state.customersList.filter(
            (j) => j.id !== action.payload.result.id
          ),
        };
        
      case ActionType.SetExpenseCats:
        return {
          ...state,
          expenseCategories: action.payload.result || [],
        };

      case ActionType.AddExpenseCat:
        return {
          ...state,
          expenseCategories: [
            action.payload.result,
            ...state.expenseCategories,
          ],
        };

      case ActionType.UpdateExpenseCat:
        return {
          ...state,
          expenseCategories: state.expenseCategories.map((j) =>
            j.id === action.payload.result.id
              ? action.payload.result
              : j
          ),
        };

      case ActionType.DeleteExpenseCat:
          return {
            ...state,
            expenseCategories: state.expenseCategories.filter(
              (j) => j.id !== action.payload.result.id
            ),
          };

      case ActionType.SetProducts:
        return {
          ...state,
          productsList: action.payload.result,
        };

      case ActionType.RmvProduct:
          return {
            ...state,
            productsList: state.productsList.filter(
              (j) => j.id !== action.id
            ),
          };

      case ActionType.SetInventory:
      return {
        ...state,
        inventoryList: [...action.payload.result],
      };

      case ActionType.SetInventories:
      return {
        ...state,
        inventoriesList: action.payload.result,
      };

      case ActionType.RmvInventory:
      return {
        ...state,
        inventoryList: state.inventoryList.filter(
          (j) => j.id !== action.id
        ),
      };
      
    case ActionType.SetCategories:
      return {
        ...state,
        categoriesList: [...action.payload.result],
      };

    case ActionType.AddCategory:
      return {
        ...state,
        categoriesList: [
          action.payload.result,
          ...state.categoriesList,
        ],
      };

    case ActionType.UpdateCategory:
      return {
        ...state,
        categoriesList: state.categoriesList.map((j) =>
          j.id === action.payload.result.id
            ? action.payload.result
            : j
        ),
      };
      
      case ActionType.RmvCategory:
        return {
          ...state,
          categoriesList: state.categoriesList.filter(
            (j) => j.id !== action.id
          ),
        };
      
    case ActionType.SetSearchResults:
      return {
        ...state,
        searchResults: [...action.payload.result],
      };

    case ActionType.SetPosItems:
      return {
        ...state,
        posItems: action.payload.result,
        type: action.payload.type,
      };

    default:
      return state;
  }
};
